import { Component, Input, Output, EventEmitter, ViewChild, ElementRef, OnDestroy, AfterViewInit } from '@angular/core';
import { AvatarCheckboxEvent } from '@finder/shared/components/avatar-checkbox/avatar-checkbox.interface';
import '@wdpr/checkbox';
import get from 'lodash-es/get';
import { fromEvent, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
    selector: 'finder-avatar-checkbox',
    templateUrl: './avatar-checkbox.component.html',
    styleUrls: ['./avatar-checkbox.component.scss']
})
export class AvatarCheckboxComponent implements AfterViewInit, OnDestroy {

    @Input() guest: any;
    @Input() disabled: boolean;
    @Input() checked: boolean;
    @Input() age: string;
    @Output() public checkedChanged = new EventEmitter<AvatarCheckboxEvent>();

    @ViewChild('checkbox', { read: ElementRef }) checkbox: ElementRef;

    private shiftKey = false;
    private destroy$ = new Subject<void>();

    constructor() { }

    ngAfterViewInit(): void {
        this.listenForShift();
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }

    getCheckBoxElm() {
        return this.checkbox.nativeElement;
    }

    sendEvent(event) {
        const checked = get(event, 'detail.value');
        this.checkedChanged.emit({
            checked,
            shiftKey: this.shiftKey,
            guestId: this.guest.xid
        });

        // Set the new checked status
        this.checked = checked;

        // Clear the event response
        this.shiftKey = false;
    }

    private listenForShift() {
        /**
         * The RA checkbox component responds to clicks on the capture phase
         * of the event chain. @HostListener only responds on the bubbling phase.
         * The solution is to use `fromEvent` and configure it to respond on the
         * capture phase. This will allow us to capture the shift button press for
         * group selection.
         */
        fromEvent(this.getCheckBoxElm(), 'click', { capture: true })
            .pipe(takeUntil(this.destroy$))
            .subscribe((event: KeyboardEvent) => {
                this.shiftKey = event.shiftKey;
            });
    }
}
